import Vue from "vue";
import Router from "vue-router";
import Store from "@/store/index.js";
import AppConsts from "@/store/consts.js";
import Permissions from "@/permissions.js";
import Home from "@/views/Home.vue";
import Home1 from "@/views/Home1.vue";
import Home2 from "@/views/Home2.vue";
import Order from "@/views/Order.vue";
import CreateOrder from "@/views/CreateOrder.vue";
import Login from "@/views/Login.vue";
import LoginForGDHRSS from "@/views/LoginForGDHRSS.vue";
import RedirectPage from "@/views/RedirectPage.vue";
import MemberCenter from "@/views/MemberCenter.vue";
import OrderInfo from "@/views/OrderInfo.vue";
import MyTicket from "@/views/MyTicket.vue";
import GroupLogin from "@/views/GroupLogin.vue";
import GroupRegist from "@/views/GroupRegist.vue";
import GroupRegistSuccess from "@/views/GroupRegistSuccess.vue";
import CreateGroupOrder from "@/views/CreateGroupOrder.vue";
import ErrorInfo from "@/views/ErrorInfo.vue";
import RegistMemberCard from "@/views/RegistMemberCard.vue";
import MemberCard from "@/views/MemberCard.vue";
import BindStaff from "@/views/BindStaff.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import DeliverOrdersOnBehalf from "@/views/DeliverOrdersOnBehalf.vue";
import DeliverOrdersOnBehalf1 from "@/views/DeliverOrdersOnBehalf1.vue";
import SubscribeWeChat from "@/views/SubscribeWeChat.vue";
import TemporaryReservationCode from "@/views/TemporaryReservationCode.vue";
import CarKeyBoard from "@/views/CarKeyBoard.vue";
import Help from "@/views/Help.vue";
import ConsumeOrderBySelf from "@/views/ConsumeOrderBySelf.vue";

import tokenService from "@/services/tokenService.js";
import memberService from "@/services/memberService.js";

const GroupExplain = () => import("@/views/GroupExplain.vue");
const QueryGroupExplain = () => import("@/views/QueryGroupExplain.vue");
const GroupCheckTicket = () => import("@/views/GroupCheckTicket.vue");
const TouristStat = () => import("@/views/report/TouristStat.vue");
const ComprehensiveReport = () =>
  import("@/views/report/ComprehensiveReport.vue");
const PassengerFlowStat = () => import("@/views/report/PassengerFlowStat.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录",
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/loginForGDHRSS",
      name: "loginForGDHRSS",
      component: LoginForGDHRSS,
      meta: {
        title: "登录",
        showTabbar: false,
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/redirectPage",
      name: "redirectPage",
      component: RedirectPage,
      meta: {
        title: "跳转",
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "首页",
        tabbarActiveIndex: 0,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/home1/:groundName",
      name: "home1",
      component: Home1,
      props: true,
      meta: {
        title: "预约须知",
        tabbarActiveIndex: 0,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/home2/:groundName",
      name: "home2",
      component: Home2,
      props: true,
      meta: {
        title: "预约须知",
        tabbarActiveIndex: 0,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/order",
      name: "order",
      component: Order,
      meta: {
        title: "订单",
        tabbarActiveIndex: 1,
        showTabbar: true
      }
    },
    {
      path: "/my",
      name: "my",
      component: MemberCenter,
      meta: {
        title: "我的",
        navbarColor: "blue",
        tabbarActiveIndex: 3,
        showTabbar: true
      }
    },
    {
      path: "/help",
      name: "help",
      component: Help,
      meta: {
        title: "获取帮助",
        navbarColor: "blue",
        tabbarActiveIndex: 2,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/createorder/:addChildren/:ticketTypeIds?",
      name: "createorder",
      component: CreateOrder,
      props: true,
      meta: {
        title: "散客领票"
      }
    },
    {
      path: "/orderinfo/:listNo",
      name: "orderinfo",
      component: OrderInfo,
      props: true,
      meta: {
        title: "订单明细"
      }
    },
    {
      path: "/myticket",
      name: "myticket",
      component: MyTicket,
      meta: {
        title: "我的门票"
      }
    },
    {
      path: "/grouplogin/:shouldBind/:nextPath/:ticketTypeIds",
      name: "grouplogin",
      component: GroupLogin,
      props: true,
      meta: {
        title: "团队登录"
      }
    },
    {
      path: "/groupregist",
      name: "groupregist",
      component: GroupRegist,
      props: route => ({ customerId: route.query.customerId }),
      meta: {
        title: "团队注册"
      }
    },
    {
      path: "/deliverordersonbehalf",
      name: "deliverordersonbehalf",
      component: DeliverOrdersOnBehalf,
      meta: {
        title: "代客下单"
      }
    },
    {
      path: "/deliverordersonbehalf1/:listNo/:dateTime/:parkId/:memberId/:explainFlag",
      name: "deliverordersonbehalf1",
      component: DeliverOrdersOnBehalf1,
      props: true,
      meta: {
        title: "临时下单"
      }
    },
    {
      path: "/Orders/EnrollOrder",
      name: "EnrollOrder",
      component: () => import("@/views/orders/EnrollOrder.vue"),
      meta: {
        title: "补登订单"
      }
    },
    {
      path: "/temporaryReservationCode",
      name: "temporaryReservationCode",
      component: TemporaryReservationCode,
      meta: {
        title: "临时下单码"
      }
    },
    {
      path: "/groupregistsuccess",
      name: "groupregistsuccess",
      component: GroupRegistSuccess,
      meta: {
        title: "注册成功"
      }
    },
    {
      path: "/changepassword/:forgetPassword/:customerId/:dateTime/:lastChangePasswordTime",
      name: "changepassword",
      props: true,
      component: ChangePassword,
      meta: {
        title: "修改密码"
      }
    },
    {
      path: "/creategrouporder/:ticketTypeIds",
      name: "creategrouporder",
      component: CreateGroupOrder,
      props: true,
      meta: {
        title: "团队预约"
      }
    },
    {
      path: "/errorinfo",
      name: "errorinfo",
      component: ErrorInfo,
      meta: {
        title: "操作失败",
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/registmembercard",
      name: "registmembercard",
      component: RegistMemberCard,
      meta: {
        title: "注册散客会员"
      }
    },
    {
      path: "/membercard",
      name: "membercard",
      component: MemberCard,
      meta: {
        title: "电子会员码",
        tabbarActiveIndex: 2
      }
    },
    {
      path: "/bindstaff",
      name: "bindstaff",
      component: BindStaff,
      meta: {
        title: "员工绑定"
      }
    },
    {
      path: "/groupexplain",
      name: "groupexplain",
      component: GroupExplain,
      meta: {
        title: "团队讲解",
        permission: Permissions.TMSWeChat_GroupExplain
      }
    },
    {
      path: "/querygroupexplain",
      name: "querygroupexplain",
      component: QueryGroupExplain,
      meta: {
        title: "讲解查询",
        permission: Permissions.TMSWeChat_QueryGroupExplain
      }
    },
    
    {
      path: "/consumeOrderBySelf/:propGroundId",
      name: "consumeOrderBySelf",
      component: ConsumeOrderBySelf,
      props: true,
      meta: {
        title: "散客检票入场",
      }
    },
    {
      path: "/groupcheckticket",
      name: "groupcheckticket",
      component: GroupCheckTicket,
      meta: {
        title: "团队检票",
        permission: Permissions.TMSWeChat_GroupCheck
      }
    },
    {
      path: "/ComprehensiveReport",
      name: "ComprehensiveReport",
      component: ComprehensiveReport,
      meta: {
        title: "综合报表",
        permission: Permissions.TMSWeChat_ComprehensiveReport
      }
    },
    {
      path: "/touriststat",
      name: "touriststat",
      component: TouristStat,
      meta: {
        title: "游客统计",
        permission: Permissions.TMSWeChat_TouristStat
      }
    },
    {
      path: "/PassengerFlowStat",
      name: "PassengerFlowStat",
      component: PassengerFlowStat,
      meta: {
        title: "客流量分析",
        permission: Permissions.TMSWeChat_PassengerFlowStat
      }
    },
    {
      path: "/SubscribeWeChat",
      name: "SubscribeWeChat",
      component: SubscribeWeChat,
      meta: {
        title: "关注微信公众号",
        allowAnonymous: true
      }
    },
    {
      path: "/carKeyBoard",
      name: "carKeyBoard",
      component: CarKeyBoard,
      meta: {
        title: "车牌"
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      const position = {};
      if (to.hash) {
        position.selector = to.hash;
      }
      if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0;
        position.y = 0;
      }
      return position;
    }
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name == "login") {
    tokenService.setToken(null);
    next();
    return;
  }
  if (to.name == "loginForGDHRSS") {
    Store.commit(AppConsts.setShowTabbar, false);
    Store.commit(AppConsts.setGDHRSSLogin, true);
    tokenService.setToken(null);
    next();
    return;
  }

  let token = tokenService.getToken();
  if(token && token.access_token_type=="GDHRSS"){
    Store.commit(AppConsts.setGDHRSSLogin, true);
  }
  else{
    Store.commit(AppConsts.setGDHRSSLogin, false);
  }

  if (!(await ensureLogined(to, from, next))) return;

  if (to.meta.permission) {
    if (
      !Store.state.memberModule.member.permissions.some(
        p => p.toLowerCase() === to.meta.permission.toLowerCase()
      )
    ) {
      next(false);
      return;
    }
  }

  window.document.title = to.meta.title;
  Store.commit(AppConsts.setTitle, to.meta.title);

  let showNavbar = to.meta.showNavbar;
  if (showNavbar === undefined) {
    showNavbar = true;
  }
  Store.commit(AppConsts.setShowNavbar, showNavbar);

  let navbarColor = to.meta.navbarColor;
  if (navbarColor === undefined) {
    navbarColor = "white";
  }
  Store.commit(AppConsts.setNavbarColor, navbarColor);

  let showTabbar = to.meta.showTabbar;
  if (showTabbar === undefined) {
    showTabbar = false;
  }
  Store.commit(AppConsts.setShowTabbar, showTabbar);

  if (to.meta.tabbarActiveIndex !== undefined) {
    Store.commit(AppConsts.activeTabbar, to.meta.tabbarActiveIndex);
  }
  next();
});

async function ensureLogined(to, from, next) {
  if (to.meta.allowAnonymous) return true;
  if (!memberService.isLogin()) {
    let wxLoginUrl = await memberService.getLoginUrl(to.path);
   
    if (wxLoginUrl) {
      next(false);
      location.href = wxLoginUrl;
      return false;
    }
  }

  return true;
}

export default router;
